import MillManagementListScreen from './MillManagementListScreen'

export default MillManagementListScreen
